export const DELIVERY_TYPE = {
  DELIVERY: 'delivery',
  STORE: 'store',
}

export const FILTER_PRE_REGISTER = {
  TRADIN: 'tradin',
  PRE_REGISTER: 'pre_regis',
}

export const CAMPAIGN_STATUS = {
  ACTIVE: 'active',
  INCOMING: 'incoming',
  EXPIRED: 'expired',
}

export const CONSENT_INPUT_TYPE = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
}

export const CONSENT_REQUIREMENT = {
  OPTIONAL: 'optional',
  MUST_ANSWER: 'must_answer',
  MUST_ACCEPT: 'must_accept',
}

export const CONSENT_INPUT_TYPES = [
  {
    value: CONSENT_INPUT_TYPE.CHECKBOX,
    label: 'label.consentInputTypeCheckbox',
  },
  {
    value: CONSENT_INPUT_TYPE.RADIO,
    label: 'label.consentInputTypeRadio',
  },
]

export const CONSENT_REQUIREMENTS = [
  {
    value: CONSENT_REQUIREMENT.OPTIONAL,
    label: 'label.consentRequirementOptional',
    color: 'grey',
  },
  {
    value: CONSENT_REQUIREMENT.MUST_ANSWER,
    label: 'label.consentRequirementMustAnswer',
    color: 'warning',
  },
  {
    value: CONSENT_REQUIREMENT.MUST_ACCEPT,
    label: 'label.consentRequirementMustAccept',
    color: 'error',
  },
]
